import { Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { BlockedComponent } from './components/blocked/blocked.component';
import { HomeComponent } from './components/home/home.component';
import { PaymentOptionsComponent } from './components/payment-options/payment-options.component';
import { RouteGuard } from './guards/route.guard';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { RegisterComponent } from './components/register/register.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SalesOrderComponent } from './components/sales-order/sales-order.component';

export const AppRoutes: Routes = [
    {
        path: 'login',
        canMatch: [LoginGuard],
        component: LoginComponent
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
         path: 'home',
         canMatch: [AuthGuard],
         component: HomeComponent
    },
    {
        path: 'payment-options',
        canMatch: [RouteGuard],
        component: PaymentOptionsComponent
    },
    {
        path: 'invoices',
        canMatch: [RouteGuard],
        component: InvoicesComponent
    },
    {
        path: 'register',
        component: RegisterComponent
    },
    {
        path: 'change-password',
        component: ChangePasswordComponent
    },
    {
        path: 'blocked',
        canMatch: [AuthGuard],
        component: BlockedComponent
    },
    {
        path: 'sales-order',
        canMatch: [RouteGuard],
        component: SalesOrderComponent
    }
];